import "./B2BProfessionalServices.module.css";
import Header from "@/reusable_sections/Header";
import IndustryHubHero from "./sections/IndustryHubHero";
import Guidance from "./sections/Guidance";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function B2BProfessionalServicesPage() {
  return <div>
      <Header />
      <IndustryHubHero />
      <Guidance />
      <RelatedServices />
      <Footer />
    </div>;
}